

var Model = require("../types/Model.js");

var CONNECTION_TIMEOUT = 15 * 1000;
var READING_TIMEOUT = 30 * 1000;

/**
	* foraIR20 Ear Temperature reading
	*/

module.exports = new Model({
	name: "forair20",
	listeners: listeners,
	triggers: triggers,
	init: init,
	uninit: uninit,

	handleTimestampReading: handleTimestampReading,
	handleConnectionFailed: handleConnectionFailed,
	handleProgressUpdated: handleProgressUpdated,
	handleBatteryReading: handleBatteryReading,
	handleFinishReading: handleFinishReading,
	handleDisconnect: handleDisconnect,
	handleFailed: handleFailed,
	readDevice: readDevice,
	cleanState: cleanState,
	clean: clean,
	info: info,
	begin: begin
});

function init() {
	this._assignedMacs = {};

	this._hasFinishedReading = false;
	this._isReading = false;
	this._isScanning = false;
	this._isConnecting = false;
	this._isListening = false;
	this._isRead = false;
	this._isWorkflow = false;
	this._deviceMac = null;
	this._hasConnected = false;

	this._timestamp = false;
	this._retryConnect = 0;
	this._retryRead = 0;
	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];

	this._connectionTimeout = null;
	this._readingTimeout = null;
	this._managerId = null;
}

function uninit() {
	this._assignedMacs = null;
	this._hasFinishedReading = false;
	this._isReading = false;
	this._isScanning = false;
	this._isConnecting = false;
	this._isListening = false;
	this._isRead = false;
	this._isWorkflow = false;
	this._deviceMac = null;
	this._hasConnected = false;

	this._timestamp = false;
	this._retryConnect = 0;
	this._retryRead = 0;
	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];

	clearTimeout(this._connectionTimeout);
	clearTimeout(this._readingTimeout);
	this._connectionTimeout = null;
	this._readingTimeout = null;
	this._managerId = null;
}

function triggers() {
	return {
		"showinfo": info,
		"workflow": workflow,
		"begin": begin,
		"clean": clean
	};
}

function listeners() {
	return {
		"bluetooth:scanned": handleScanned,
		"bluetooth:connected": handleDeviceConnected,
		"bluetooth:event": handleEvent,
		"bluetooth:disconnected": handleDeviceDisconnected,
		"bluetooth:failed": handleFailed,
		"owndevices:updated": handle_devices_update,
		"activemanagegroup:updated": handleManageGroupUpdated
	};
}

function info(data){
	var trigger = "forair20:trigger:begin";
	var message = "myhealthdevice.forair20prepmessage";

	this.emit("bluetooth:trigger:initialize");

	if(data && data.who) this._managerId = data.who;

	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.prepare",
		items: {
			prepare: {
				message: message,
				type: "confirmcancel",
				trigger: trigger,
				cancelTrigger: "myhealthdevice:trigger:clean",
			}
		}
	});

	this.emit("usermetrics:trigger:track", "open read from device modal for body temperature", {
		"device type": "forair20",
	});
}

function begin(){
	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.read",
		items: {
			connect: {
				type: "load",
				progress: 0,
				message: "myhealthdevice.connecting"
			},
			reading: {
				type: "progress",
				progress: 0,
				message: "myhealthdevice.reading",
				cancelTrigger: "myhealthdevice:trigger:clean"
			}
		}
	});

	this.emit("usermetrics:trigger:track", "begin read from device for body temperature", {
		"device type": "forair20",
	});

	this.readDevice();
}

function readDevice(){
	this._isScanning = true;

	this._connectionTimeout = setTimeout(handleConnectionFailed.bind(this), CONNECTION_TIMEOUT);

	this.emit("bluetooth:trigger:scan");
	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 0,
			type: "load",
			message: "myhealthdevice.scanning"
		}
	});
}

function handleScanned(scanned){
	var name = "FORA IR20";
	var isScanning = this._isScanning;

	var macs = this._assignedMacs;
	var macKeys = Object.keys(macs);
	var isMacs = macKeys.length;
	var macExists = macKeys.indexOf(scanned.id) !== -1;

	if(!isScanning) return;
	if(!(scanned && scanned.name && scanned.name.indexOf(name) !== -1)) return;
	if(isMacs && !macExists) return;

	var found = scanned.id;
	this._isScanning = false;
	this._isConnecting = true;
	this._deviceMac = found;

	this.emit("bluetooth:trigger:scan:stop");
	this.emit("bluetooth:trigger:connect", {
		mac: found,
		model: "forair20"
	});
	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 0,
			type: "load",
			message: "myhealthdevice.connecting"
		}
	});
}

function handleDeviceConnected(){
	var isConnecting = this._isConnecting;
	if(!isConnecting) return;

	this._isConnecting = false;
	this._hasConnected = true;
	this._isListening = true;

	clearTimeout(this._connectionTimeout);
	this._readingTimeout = setTimeout(handleFailed.bind(this), READING_TIMEOUT);

	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 1,
			type: "load",
			message: "myhealthdevice.connected"
		}
	});

	this.emit("bluetooth:trigger:listen", {
		service: "FORA_TNG_SERVICE",
		characteristic: "FORA_TNG_READWRITE_CHARACTERISTIC",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:write", {
		service: "FORA_TNG_SERVICE",
		characteristic: "FORA_TNG_READWRITE_CHARACTERISTIC",
		value: "FORA_TNG_TIME",
		device: this._deviceMac
	});
}

function handleEvent(event){
	var hasFinishedReading = this._hasFinishedReading;
	var isListening = this._isListening;
	var readings = this._readings;

	var char = event.characteristic;
	if(!isListening || hasFinishedReading) return;

	var data = event.data;

	this._isRead = true;
	clearTimeout(this._readingTimeout);

	if(char === "FORA_TNG_READWRITE_CHARACTERISTIC"){
		if(this._isReading){
			this._readings = readings.concat(data);
			this.handleFinishReading();
		} else {
			this._timeRead = event.data;
			this.handleTimestampReading();
		}
		this.handleProgressUpdated();
	}
}

function handleProgressUpdated(){
	var progress = this._progress;

	if(progress < 1)
		progress++;

	this.emit("feedbackmodal:trigger:update", {
		reading: {
			type: "progress",
			message: "myhealthdevice.reading",
			progress: progress / 1,
			cancelTrigger: "myhealthdevice:trigger:clean"
		}
	});

	this._progress = progress;
}

function handleFinishReading(){
	var readings = this._readings;
	var isWorkflow = this._isWorkflow;
	var isRead = this._isRead;
	var units = this._units;
	var manageGroup = this._manageGroup;

	if(!isRead) return;

	var reading = formatReading(readings, units);

	this._hasFinishedReading = true;

	var processReading = null;
	if(isWorkflow){
		processReading = handleWorkflow.bind(this);
	} else if(this._managerId) {
		reading.managerId = this._managerId;
		if(manageGroup)
			reading.group = manageGroup;
		processReading = this.api.manage.bodytemperature.add;
	} else {
		processReading = this.api.device.bodytemperature.add;
	}

	return processReading(reading)
		.then(function(){
			setTimeout(handleDisconnect.bind(this), 3000);
		}.bind(this)).catch(function(e){
			console.log("Error submitting steps: ", e);
		});
}

function handleTimestampReading(){
	var reading = this._timeRead;
	var units = getUnits(reading);

	this._readingTimeout = setTimeout(handleFailed.bind(this), READING_TIMEOUT);

	this._isReading = true;
	this._units = units;

	this.emit("bluetooth:trigger:write", {
		service: "FORA_TNG_SERVICE",
		characteristic: "FORA_TNG_READWRITE_CHARACTERISTIC",
		value: "FORA_TNG_READING",
		device: this._deviceMac
	});
}

function handleWorkflow(reading){
	return new Promise(function(resolve){
		var legible = legibleReading(reading);
		this.dispatch("reading", {
			legible: legible,
			value: reading
		});
		resolve();
	}.bind(this));
}

function handleDisconnect(){
	var isListening = this._isListening;
	var hasConnected = this._hasConnected;
	var deviceMac = this._deviceMac;

	if(isListening){
		this._isListening = false;
		this.emit("bluetooth:trigger:listen:stop", {
			service: "FORA_TNG_SERVICE",
			characteristic: "FORA_TNG_READWRITE_CHARACTERISTIC",
			device: this._deviceMac
		});
	}

	if(hasConnected){
		this._isDisconnecting = true;
		this._hasConnected = false;
		this.emit("bluetooth:trigger:disconnect", {
			mac: deviceMac
		});
	}
}

function handleDeviceDisconnected(){
	var hasFinishedReading = this._hasFinishedReading;
	if(hasFinishedReading)
		this.clean();
	else
		this.handleFailed();
}

function handleFailed(){
	var isScanning = this._isScanning;
	var isConnecting = this._isConnecting;
	var hasConnected = this._hasConnected;
	var retryConnect = this._retryConnect;
	var isWorkflow = this._isWorkflow;

	if((isScanning || isConnecting || hasConnected) && retryConnect <= 2){
		this.handleConnectionFailed();
		return;
	}

	if(!(isScanning || isConnecting || hasConnected)) return;

	this._hasFailed = true;

	this.clean();
	this._isWorkflow = isWorkflow;

	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.failedtitle",
		items: {
			continue: {
				message: "myhealthdevice.failed",
				type: "confirmcancel",
				trigger: "myhealthdevice:trigger:begin",
				cancelTrigger: "myhealthdevice:trigger:clean"
			}
		}
	});

	this.handleDisconnect();
}

function handleConnectionFailed(){
	var retried = ++this._retryConnect;

	clearTimeout(this._connectionTimeout);

	if(retried <= 2)
		this.readDevice();
	else
		this.handleFailed();
}

function clean(){
	this.emit("feedbackmodal:trigger:hide");
	if(this._isScanning)
		this.emit("bluetooth:trigger:scan:stop");
	this.cleanState();
}

function cleanState(){
	if(this._hasConnected || this._isListening)
		this.handleDisconnect();

	this._hasFinishedReading = false;
	this._isReading = false;
	this._isScanning = false;
	this._isConnecting = false;
	this._isListening = false;
	this._isRead = false;
	this._isWorkflow = false;
	this._deviceMac = null;
	this._hasConnected = false;

	this._timestamp = false;
	this._retryConnect = 0;
	this._retryRead = 0;
	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];

	clearTimeout(this._connectionTimeout);
	clearTimeout(this._readingTimeout);
	this._connectionTimeout = null;
	this._readingTimeout = null;
}


function workflow() {
	this._isWorkflow = true;
	this.info();
}

function handleBatteryReading(){
	var deviceMac = this._deviceMac;
	var readings = this._batteryReadings;
	var reading = formatBatteryReading(readings);

	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 1,
			type: "load",
			message: "myhealthdevice.batterylevel",
			messageArgs: {
				battery: reading
			}
		}
	});

	var assignedMacs = this._assignedMacs;

	if(!Object.keys(assignedMacs).length) return;
	var device = assignedMacs[deviceMac];
	if(!device) return;

	return this.api.devices.battery(device._id, reading);
}

function getUnits(reading){
	var bytes = reading[5];
	var bin = padBinary(bytes.toString(2));
	var byte = bin[0];

	if(byte === "0")
		return "celsius";
	else if(byte === "1")
		return "fahrenheit";
}

function formatReading(readings, units) {
	var reading = readings[readings.length - 1];
	var data0 = reading[2];
	var data1 = reading[3];
	var combined = padBinary(data1.toString(2)) + padBinary(data0.toString(2));
	var value = parseInt(combined, 2) * 0.1;
	return {
		temperature: value,
		units: units,
	};
}

function legibleReading(readings) {
	return parseFloat(readings.temperature).toFixed(1) + " " + readings.units;
}

function formatBatteryReading(readings){
	var latestReading = readings[readings.length - 1];
	return latestReading[0];
}

function handle_devices_update(data){
	var list = data.list;

	var newMacs = list.reduce(function(acc, device){
		if(device.device_type === "bodytemperature"){
			acc[device.mac] = device;
		}
		return acc;
	}, {});

	this._assignedMacs = newMacs;
}

function padBinary(string){
	while(string.length < 8) string = "0" + string;
	return string;
}

function handleManageGroupUpdated(group){
	this._manageGroup = group;
}